import Layout from 'HorizontalMenu/Menu'
import React from 'react'
import { Container, Table, Button, Navbar, Row } from 'reactstrap'

// Sample object array
const portData = [
    {
        vessel: 'Evergreen',
        voyage: 'EV1234',
        report: 'Report A'
    },
    {
        vessel: 'Maersk',
        voyage: 'MK5678',
        report: 'Report B'
    },
    {
        vessel: 'COSCO',
        voyage: 'CS9101',
        report: 'Report C'
    }
]

const PortMasterUpdate = () => {
    return (
        <React.Fragment>
            <Layout>
                <Navbar />
            </Layout>
            <div className="page-content">
                <Container fluid>
                    <h4 className="mb-4">Other Port Import</h4>
                    <Table responsive>
                        <thead className='table-light'>
                            <tr>
                                <th>#</th>
                                <th>Vessel</th>
                                <th>Voyage</th>
                                <th>Report</th>
                            </tr>
                        </thead>
                        <tbody>
                            {portData.map((item, index) => (
                                <tr key={index}>
                                    <th scope="row">{index + 1}</th>
                                    <td>{item.vessel}</td>
                                    <td>{item.voyage}</td>
                                    <td>{item.report}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    <Row className="mb-4">
                        <div className="d-flex justify-content-end">
                            <Button color="primary" className="btn_size4_5_cstm">
                                Update
                            </Button>
                        </div>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default PortMasterUpdate
